var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIndustrial = function SvgIndustrial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "industrial_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#industrial_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.47 6.965c1.666.408 3.284.959 4.939 1.415l.048.036v8.128h-1.175v-6.246H5.718v6.246H4.543v-8.14l9.927-1.439Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.612 16.544H6.354v-1.271h1.258v1.27ZM9.483 16.544h-1.26v-1.271h1.26v1.27ZM11.34 16.544h-1.258v-1.271h1.259v1.27ZM13.415 16.544h-1.26v-1.271h1.26v1.27ZM15.285 16.544h-1.26v-1.271h1.26v1.27ZM17.155 16.544h-1.259v-1.271h1.259v1.27ZM7.612 14.673H6.354v-1.27h1.258v1.27ZM9.483 13.403v1.27h-1.26v-1.27h1.26ZM11.34 14.673h-1.258v-1.27h1.259v1.27ZM13.415 14.673h-1.26v-1.27h1.26v1.27ZM15.285 14.673h-1.26v-1.27h1.26v1.27ZM17.155 14.673h-1.259v-1.27h1.259v1.27ZM7.612 12.755l-.036.048H6.354v-1.27h1.258v1.222ZM9.483 12.803h-1.26v-1.27h1.26v1.27ZM15.285 12.803h-1.26v-1.27h1.26v1.27Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "industrial_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgIndustrial as ReactComponent };